import { gql } from '@apollo/client/core'

export const NEW_GUEST_SETUP_INTENT_MUTATION = gql`
  mutation newGuestSetupIntent($input: NewGuestSetupIntentInput!) {
    newGuestSetupIntent(input: $input) {
      ... on NewGuestSetupIntentOutput {
        guestUserId
        clientSecret
      }
    }
  }
`
